module.exports = __webpack_public_path__ + "img/home_menu_5_selected.dd5dee82.png";